import * as React from 'react';
import { useSelector } from 'react-redux';
import { VisibleViolationsWarning } from './VisibleViolationsWarning';
import { selectIsVisibleViolationsExist } from '../../selectors/visibleViolations';
import { openModal } from '../../utils/modals';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../selectors/analytics';
import { trackPublishWithVisibleViolationsClick } from './VisibleViolationsWarning.tracking';

export const VisibleViolationsWarningContainer = () => {
  const isVisibleViolationsExist = useSelector(selectIsVisibleViolationsExist);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);

  const handleForcePublishClick = React.useCallback(() => {
    openModal('premoderationConfirm');

    trackPublishWithVisibleViolationsClick(analyticsProduct, analyticsOfferStatus);
  }, [openModal, trackPublishWithVisibleViolationsClick, analyticsProduct, analyticsOfferStatus]);

  if (!isVisibleViolationsExist) {
    return null;
  }

  return <VisibleViolationsWarning handleForcePublishClick={handleForcePublishClick} />;
};
